import classNames from 'classnames'
import React from 'react'
import cl from '../../../classnames.scss'
import {SubtitleProps} from './interfaces'
import s from './subtitle.scss'

export const Subtitle: React.FC<SubtitleProps> = ({dataHook, lines, noBottomMargin}) => (
  <div
    className={classNames(cl.textFont, cl.formLabelsColor, s.subtitle, noBottomMargin && s.noBottomMargin)}
    data-hook={dataHook}
  >
    {lines.map(text => text && <div key={text}>{text}</div>)}
  </div>
)
